import React, { Component } from 'react'
import {
        NavLink as Link,
} from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Navbar, Container, Nav} from 'react-bootstrap'
import './css/Navbar.css'



class MyNavbar extends Component {
        constructor(props) {
                super()
                var url = window.location.pathname
                this.state = {
                        url: url,
                        bgcolor: props.backgroundColor || "none"
                }
        }
        logout() {
                window.localStorage.removeItem('auth-token');
                window.location.replace('/');
        }
        render() {
                var auth = JSON.parse(localStorage.getItem('auth-token'))
                return (
                        <Navbar expand="lg" id="main_navbar" style={{backgroundColor: this.state.bgcolor}}>
                                {
                                        auth ?
                                                <Container >
                                                        <Navbar.Brand href="/">
                                                                <img
                                                                        src={process.env.PUBLIC_URL + '/logo3.png'}
                                                                        height="40"
                                                                        className="d-inline-block align-top logo"
                                                                        alt="React Bootstrap logo"
                                                                />
                                                                <label className="font-weight-bold ml-3 nav_bar_brand"><span className="text-primary">A</span>NALYZE IT</label>
                                                        </Navbar.Brand>
                                                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                                                        <Navbar.Collapse>
                                                                <Nav className="nav-link-container">
                                                                        <Link className="nav-link" to="/">Home</Link>
                                                                        <Link className="nav-link" activeClassName="active-nav-link" to="/reviews">Reviews</Link>
                                                                        <Link className="nav-link" activeClassName="active-nav-link" to="/Developer-Mohit_Patidar">Developer</Link>
                                                                        <Link className="nav-link" activeClassName="active-nav-link" to='/workspace'>Workspace</Link>
                                                                        <label className="nav-link" onClick={() => { this.logout() }}>Logout</label>
                                                                </Nav>
                                                        </Navbar.Collapse>
                                                </Container>
                                                :
                                                <Container>
                                                        <Navbar.Brand href="/">
                                                                <img
                                                                        src={process.env.PUBLIC_URL + '/logo3.png'}
                                                                        height="40"
                                                                        className="d-inline-block align-top logo"
                                                                        alt="React Bootstrap logo"
                                                                />
                                                                <label className="font-weight-bold ml-3 nav_bar_brand"><span className="text-primary">A</span>nalyze It</label>
                                                        </Navbar.Brand>
                                                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                                                        <Navbar.Collapse>
                                                                <Nav className="nav-link-container">
                                                                        <Link className="nav-link" to="/">Home</Link>
                                                                        <Link className="nav-link" activeClassName="active-nav-link" to="/reviews">Reviews</Link>
                                                                        <Link className="nav-link" activeClassName="active-nav-link" to="/Developer-Mohit_Patidar">Developer</Link>
                                                                        <Link className="nav-link" activeClassName="active-nav-link" to={{ pathname: "/auth", IsSignin: false }}>Signup</Link>
                                                                        <Link className="nav-link" activeClassName="active-nav-link" to={{ pathname: "/auth", IsSignin: true }}>Signin</Link>
                                                                </Nav>
                                                        </Navbar.Collapse>
                                                </Container>
                                }
                        </Navbar>
                )
        }
}

export default MyNavbar
